/** Head data of the public pages. Each page module exports its own `meta`
 * next to the component, so the text and its title/description change
 * together; the prerender step turns it into <head> tags, JSON-LD and the
 * sitemap (scripts/prerender.mjs, entry-server.tsx). */

import { BRAND, DEMO_PHONE } from '@/landing/content'

export const SITE_URL = 'https://anytel.com.ua'

export interface PageMeta {
  /** ≤ 60 characters; the brand goes last. */
  title: string
  /** ≤ 160 characters. */
  description: string
  /** Kept out of search results and the sitemap (404). */
  noindex?: boolean
  /** Date of the last real change to the text, YYYY-MM-DD, for the sitemap. */
  updated?: string
  /** schema.org nodes, rendered as one JSON-LD @graph. */
  schema?: Record<string, unknown>[]
}

export const OG_IMAGE = {
  path: '/og/anytel.png',
  width: 1200,
  height: 630,
  alt: 'Anytel: ваш телефон відповідає сам. AI-адміністратор приймає дзвінки 24/7 українською.',
}

export const ORGANIZATION_ID = `${SITE_URL}/#organization`

export function organization(): Record<string, unknown> {
  const email = import.meta.env.VITE_CONTACT_EMAIL
  return {
    '@type': 'Organization',
    '@id': ORGANIZATION_ID,
    name: BRAND,
    url: `${SITE_URL}/`,
    logo: `${SITE_URL}/og/logo-512.png`,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: DEMO_PHONE,
      contactType: 'sales',
      areaServed: 'UA',
      availableLanguage: ['uk'],
      ...(email ? { email } : {}),
    },
  }
}

export interface Crumb {
  name: string
  path: string
}

export function breadcrumbList(items: Crumb[]): Record<string, unknown> {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: SITE_URL + it.path,
    })),
  }
}

export function website(): Record<string, unknown> {
  return {
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    name: BRAND,
    url: `${SITE_URL}/`,
    inLanguage: 'uk',
    publisher: { '@id': ORGANIZATION_ID },
  }
}
